import { Box, Chip, Typography, useMediaQuery } from "@mui/material"

const steps = [
    {
        number: "1",
        title: "Pick username",
        description: "Sign up and pick your username.",
    },
    {
        number: "2",
        title: "Upload video",
        description: "Upload or record a short clip. It becomes your page's background.",
    },
    {
        number: "3",
        title: "Add links & socials",
        description: "Drop in your socials, links, shop, calendar, music, anything.",
    },
    {
        number: "4",
        title: "Start tracking",
        description: "See page visits, CTRs, track Revenue Links, generate Brand Reports for your next partnership.",
    },
]

export default function HowItWorksSection() {
    const isMobile = useMediaQuery('(max-width:950px)')

    const styles = {
        container: (isMobile) => ({
            margin: isMobile ? '1.2rem .8rem' : '4rem 14vw',
            padding: isMobile ? '2rem 1.2rem' : '3rem 6vw',
            borderRadius: '40px',
            backgroundColor: 'primary.bg2',
            fontFamily: 'Catamaran',
        }),
        sectionLabel: {
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: '0.85rem',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            mb: 1.5,
            textAlign: 'center',
        },
        heading: (isMobile) => ({
            fontFamily: 'inherit',
            fontWeight: 900,
            color: 'primary.black',
            textAlign: 'center',
            mb: 1,
            fontSize: isMobile ? '1.8rem' : '2rem',
        }),
        subheading: {
            fontFamily: 'inherit',
            fontWeight: 500,
            color: 'text.gray',
            textAlign: 'center',
            mb: 5,
            fontSize: '1.1rem',
        },
        stepsContainer: (isMobile) => ({
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? 4 : 3,
            justifyContent: 'center',
        }),
        stepCard: (isMobile) => ({
            flex: 1,
            textAlign: isMobile ? 'center' : 'left',
            p: '1rem',
        }),
        stepNumber: {
            fontFamily: 'inherit',
            fontWeight: 800,
            fontSize: '2.4rem',
            color: 'primary.main',
            mb: 1,
        },
        stepTitle: {
            fontFamily: 'inherit',
            fontWeight: 800,
            fontSize: '1.2rem',
            color: 'primary.black',
            mb: 1,
        },
        stepDescription: {
            fontFamily: 'inherit',
            fontWeight: 500,
            fontSize: '1rem',
            color: 'text.gray',
        },
    }

    return (
        <Box id="how-it-works" sx={styles.container(isMobile)}>
            <Chip
                label="How it works"
                size="small"
                sx={{
                    display: 'flex',
                    width: 'fit-content',
                    m: '0 auto 1rem auto',
                    fontFamily: 'Catamaran',
                    fontWeight: 700,
                    backgroundColor: 'primary.main',
                    color: '#fff',
                }}
            />
            <Typography
                variant={isMobile ? 'h4' : 'h3'}
                component="h2"
                sx={styles.heading(isMobile)}
            >
                Live in a minute. Seriously.
            </Typography>
            <Typography
                variant="body1"
                component="p"
                sx={styles.subheading}
            >
                Four steps. No learning curve. No templates to wrestle with.
            </Typography>

            <Box sx={styles.stepsContainer(isMobile)}>
                {steps.map((step) => (
                    <Box key={step.number} sx={styles.stepCard(isMobile)}>
                        <Typography sx={styles.stepNumber}>
                            {step.number}
                        </Typography>
                        <Typography sx={styles.stepTitle}>
                            {step.title}
                        </Typography>
                        <Typography sx={styles.stepDescription}>
                            {step.description}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
